import React from "react";
import RatingIndicator from "../RatingIndicator";
import styles from "../../../assets/styles/cardNews/TimelineCardWithThumbnail.module.css";
import img from "../../../assets/images/thumbnail_default.jpg";
import PressNDate from "./PressNDate";
import { Obscure } from "../\bobscuredImage";

const TimelineCardWithThumbnail = ({ news, main, color = "" }) => {
  return (
    <div
      className={`${styles.card_container} ${main}`}
      style={{ backgroundColor: color, border: !!color ? "none" : "" }}
    >
      <div className={styles.card_top}>
        <RatingIndicator signal={news.staticsentimental.signal} />
        {/*<span>{news.press}·{news.registdate}</span>*/}
        <PressNDate press={news.press} date={news.registdate} />
      </div>
      <div className={styles.card_contents}>
        <div>
          <div className={styles.card_news}>
            <p className={`${styles.title} ${main}`}>{news.subject}</p>
            <p className={styles.summary}>{news.summary}</p>
          </div>
          <div className={styles.card_footer}>
            <span className={styles.stockname}>{news.stockname}</span>
          </div>
        </div>
        <Obscure text={news?.press}>
          <img
            className={styles.thumbnail}
            src={news.imgsrc || img}
            alt={news.subject}
          />
        </Obscure>
      </div>
    </div>
  );
};

export default TimelineCardWithThumbnail;
